import { IconSignUpScroll } from '@medifind/icons';
import { eventDispatch } from '@medifind/utils';
import { useAuthentication } from '@medifind/zustand';
import AdWrapper from './adWrapper';

const SignUpAd = ({ isWhite, tagLine, loginMessage, ...props }) => {
  const { profile } = useAuthentication();

  return (
    <>
      {!profile && (
        <AdWrapper
          {...props}
          icon={<IconSignUpScroll size={'small'} />}
          title={tagLine}
          onClick={() =>
            eventDispatch('activateAuth', {
              errorMessage: loginMessage,
              authType: 'register',
            })
          }
          buttonText={'Sign Up'}
        />
      )}
    </>
  );
};

export { SignUpAd as default, SignUpAd };
